export const TEST_ID = 'authChecker';
